import { useEffect, useState } from 'react'
import discoverApi from '../../client/discover-api'
import { MediaGridItem } from '../../types/Media'
import MediaGridPage from '../../areas/layout/media-grid-page'

const DiscoverPage = () => {
  const [items, setItems] = useState<MediaGridItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  const loadPage = async (p: number) => {
    try {
      setLoading(true)
      const res = await discoverApi.get(p)

      if (!res || !res.results) {
        setHasMore(false)
        return
      }

      setItems((prev) => [...prev, ...res.results])

      setHasMore(p < res.totalPages)
    } catch {
      setError('Failed to load')
      setHasMore(false)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadPage(1)
  }, [])

  const handleLoadMore = () => {
    if (loading || !hasMore) return
    const next = page + 1
    setPage(next)
    loadPage(next)
  }

  return (
    <MediaGridPage
      title='Discover'
      subtitle='Explore Trending Movies and Shows'
      items={items}
      loading={loading}
      error={error}
      hasMore={hasMore}
      onLoadMore={handleLoadMore}
    />
  )
}

export default DiscoverPage
